const carsForFilter = {
	chevrolet: {
		silverado: {
			2001: ['6.6L', '8.1L'],
			2002: ['6.6L', '8.1L'],
			2003: ['6.6L', '8.1L'],
			2004: ['6.6L', '8.1L'],
			2005: ['6.6L', '8.1L'],
		},
	},
	dodge: {
		'ram-truck-cummins': {
			1998: ['5.9L'],
			1999: ['5.9L'],
		},
	},
	gmc: {
		sierra: {
			2001: ['6.6L', '8.1L'],
			2002: ['6.6L', '8.1L'],
			2003: ['6.6L', '8.1L'],
			2004: ['6.6L', '8.1L'],
			2005: ['6.6L', '8.1L'],
		},
	},
	jeep: {
		wrangler: {
			2003: ['2.4L', '4.0L'],
			2004: ['2.4L', '4.0L'],
		},
	},
};
